<template>
  <span>
    <b-icon
      pack="fas"
      v-bind:icon="icons[portfolioType].icon"
      v-bind:class="icons[portfolioType].color"
    />
  </span>
</template>

<script>
  export default {
    data() {
      return {
        icons: {
          prospect: {
            icon: 'comments-dollar',
            color: 'has-text-primary'
          },
          shareowner: {
            icon: 'user-friends',
            color: 'has-text-warning'
          },
          modelportfolio: {
            icon: 'chart-pie',
            color: 'has-text-info'
          },
          ticker: {
              icon: 'file-invoice-dollar',
              color: 'has-text-grey-light'
          }
        }
      }
    },
    props: {
      portfolioType: String,
    },
  }
</script>

<style scoped>
.icon {
  font-size: 2.5em;
}
</style>
